import {
    SET_NOMBRE_CITAS_SERVICIO,
    SET_APELLIDO_MATERNO_CITAS_SERVICIO,
    SET_APELIIDO_PATERNO_CITAS_SERVICIO,
    SET_ESTADO_CITAS_SERVICIO,
    SET_ID_CONCESIONARIO_CITAS_SERVICIO,
    SET_CONCESIONARIO_CITAS_SERVICIO,
    SET_TELEFONO_CITAS_SERVICIO,
    SET_CORREO_CITAS_SERVICIO,
    SET_FECHA_CITA_CITAS_SERVICIO,
    SET_HORARIO_CITA_CITAS_SERVICIO,
    SET_MODELO_AUTO_CITAS_SERVICIO,
    SET_YEAR_AUTO_CITAS_SERVICIO,
    SET_SERVICIO_CITAS_SERVICIO,
    SET_COMENTARIOS_CITAS_SERVICIO,
    SET_AVISO_PRIVACIDAD_CITAS_SERVICIO,
    SET_DEALER_URLS,
    SET_UUID_CITAS_SERVICIO,
    SET_CITAS_DISPONIBLES_CITAS_SERVICIO,
    SET_ID_CITA_CITAS_SERVICIO,
    SET_LIST_ESTADOS_CITAS_SERVICIO,
    SET_LIST_CONCESIONARIOS_CITAS_SERVICIO,
    SET_LIST_MODELOS_CITAS_SERVICIO,
    SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO,
    RESET_STATE_CITAS_SERVICIO,
    SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO,
    SET_ERROR_CONSULTAR_CITAS_SERVICIO,
    SET_CORREO_CONTACTO_CITAS_SERVICIO,
    SET_DEALER_HORARIOS_OFFLINE
} from "../types";

const initialState = {
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    estado: "",
    idConcesionario: "",
    concesionario: "",
    telefono: "",
    correo: "",
    fechaCita: "",
    horarioCita: "",
    modeloAuto: "",
    yearModelo: "",
    numeroChasis: " ",
    servicio: "",
    comentarios: "",
    avisoPrivacidad: false,
    dealerUrls: [],
    uuid: "",
    citasDisponibles: [],
    listEstados: [],
    listConcesionarios: [],
    listModelos: [],
    listFechasHorarios: [],
    buscaFechasLoading: false,
    errorConsultarHorarios: false,
    idCita: "",
    correoContacto: [],
    horariosDealerOffline: []
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_NOMBRE_CITAS_SERVICIO:
            return {
                ...state,
                nombre: action.payload
            };
        case SET_APELIIDO_PATERNO_CITAS_SERVICIO:
            return {
                ...state,
                apellidoPaterno: action.payload
            };
        case SET_APELLIDO_MATERNO_CITAS_SERVICIO:
            return {
                ...state,
                apellidoMaterno: action.payload
            };
        case SET_ESTADO_CITAS_SERVICIO:
            return {
                ...state,
                estado: action.payload
            };
        case SET_ID_CONCESIONARIO_CITAS_SERVICIO:
            return {
                ...state,
                idConcesionario: action.payload
            };
        case SET_CONCESIONARIO_CITAS_SERVICIO:
            return {
                ...state,
                concesionario: action.payload
            };
        case SET_TELEFONO_CITAS_SERVICIO:
            return {
                ...state,
                telefono: action.payload
            };
        case SET_CORREO_CITAS_SERVICIO:
            return {
                ...state,
                correo: action.payload
            };
        case SET_FECHA_CITA_CITAS_SERVICIO:
            return {
                ...state,
                fechaCita: action.payload
            };
        case SET_HORARIO_CITA_CITAS_SERVICIO:
            return {
                ...state,
                horarioCita: action.payload
            };
        case SET_MODELO_AUTO_CITAS_SERVICIO:
            return {
                ...state,
                modeloAuto: action.payload
            };
        case SET_YEAR_AUTO_CITAS_SERVICIO:
            return {
                ...state,
                yearModelo: action.payload
            };
        case SET_SERVICIO_CITAS_SERVICIO:
            return {
                ...state,
                servicio: action.payload
            };
        case SET_COMENTARIOS_CITAS_SERVICIO:
            return {
                ...state,
                comentarios: action.payload
            };
        case SET_AVISO_PRIVACIDAD_CITAS_SERVICIO:
            return {
                ...state,
                avisoPrivacidad: action.payload
            };
        case SET_DEALER_URLS:
            return {
                ...state,
                dealerUrls: action.payload
            };
        case SET_UUID_CITAS_SERVICIO:
            return {
                ...state,
                uuid: action.payload
            };
        case SET_CITAS_DISPONIBLES_CITAS_SERVICIO:
            return {
                ...state,
                citasDisponibles: action.payload
            };
        case SET_ID_CITA_CITAS_SERVICIO:
            return {
                ...state,
                idCita: action.payload
            };
        case SET_LIST_ESTADOS_CITAS_SERVICIO:
            return {
                ...state,
                listEstados: action.payload
            };
        case SET_LIST_CONCESIONARIOS_CITAS_SERVICIO:
            return {
                ...state,
                listConcesionarios: action.payload
            };
        case SET_LIST_MODELOS_CITAS_SERVICIO:
            return {
                ...state,
                listModelos: action.payload
            };
        case SET_LIST_FECHAS_HORARIOS_CITAS_SERVICIO:
            return {
                ...state,
                listFechasHorarios: action.payload
            };
        case RESET_STATE_CITAS_SERVICIO:
            return initialState;
        case SET_BUSCA_FECHAS_LOADING_CITAS_SERVICIO:
            return {
                ...state,
                buscaFechasLoading: action.payload
            };
        case SET_ERROR_CONSULTAR_CITAS_SERVICIO:
            return {
                ...state,
                errorConsultarHorarios: action.payload
            };
        case SET_CORREO_CONTACTO_CITAS_SERVICIO:
            return {
                ...state,
                correoContacto: action.payload
            };
        case SET_DEALER_HORARIOS_OFFLINE:
            return {
                ...state,
                horariosDealerOffline: action.payload
            };
            
            
        default:
            return state
    }
}